module.exports = __webpack_public_path__ + "static/media/project-2.3f8e385e.PNG";